// Production environment
import packageInfo from '../../../package.json';
import { documentationUrls } from './documentation-urls';

export const environment = {
  environment: 'production',
  production: true,
  devMode: false, //disables annoying features like lockscreen while developing
  ssoAllowed: true, // only available on staging & production

  version: packageInfo?.version,

  authAppURL: 'https://login.reconcept.nl',
  authApiURL: 'https://api.portfolio.reconcept.nl',

  portfolioClientName: 'APOLLO_PORTFOLIO',
  portfolioAppURL: 'https://portfolio.reconcept.nl',
  portfolioApiURL: 'https://api.portfolio.reconcept.nl/graphql',

  aiApiUrl: 'https://api.ai.reconcept.nl/api/ai',

  workspaceAppURL: 'https://workspace.reconcept.nl',
  workspaceApiURL: 'https://api.portfolio.reconcept.nl/graphql',

  ...documentationUrls,

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept',
  otpBannerEnabled: true,

  environmentIndicator: {},
};
